module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_04.dot-053cea5661bdaf6b085094b7ca13b780.svg";